module.exports = __webpack_public_path__ + "static/media/soccer_ball.1b84e582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/soccer_ball.png
// module id = 808
// module chunks = 2